import { styled } from "@iventis/styles";
import React, { FunctionComponent, ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Body2 } from "@iventis/styles/src/components/texts";
import { matchHeightToWidth } from "@iventis/styles/src/composite-rules";
import { borderRadius } from "@iventis/styles/src/atomic-rules";
import { Theme } from "@emotion/react";
import { InteractiveElement } from "@iventis/styles/src/components";

export const ThumbnailedSelector: FunctionComponent<{
    onClick: () => void;
    showOutline: boolean;
    showTick: boolean;
    text: ReactNode;
    imageUrl: string;
    dataTestId?: string;
    title?: string;
    badge?: ReactNode;
}> = ({ showOutline, showTick, onClick, imageUrl, text, dataTestId, title, badge }) => (
    <OptionContainer type="button" onClick={() => onClick()} data-testid={dataTestId}>
        <StyledImage imageUrl={imageUrl} showOutline={showOutline} role="img">
            {badge && <BadgeContainer>{badge}</BadgeContainer>}
            {showTick && <FontAwesomeIcon size="lg" icon={["fas", "check-circle"]} />}
        </StyledImage>
        <Body2 className="name" title={title}>
            {text}
        </Body2>
    </OptionContainer>
);

const OptionContainer = styled(InteractiveElement)`
    min-width: 0;

    p {
        margin: 5px;
        text-align: left;
        word-break: break-word;
    }
`;

const StyledImage = styled.div<{ imageUrl: string; showOutline: boolean }>`
    position: relative;
    ${matchHeightToWidth("2px")}

    border-radius: ${borderRadius.standard};
    border: 2px solid ${({ showOutline, theme }) => (showOutline ? (theme as Theme).primaryColors.focus : "transparent")};

    background-image: url(${({ imageUrl }) => imageUrl});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .name {
        font-weight: 500;
    }

    svg {
        position: absolute;
        bottom: 6px;
        right: 6px;
        color: ${({ theme }: { theme: Theme }) => theme.primaryColors.focus};
        background: #fff;
        border-radius: 50%;
        box-shadow: 0 0 0 2px #fff;
    }
`;

const BadgeContainer = styled.div`
    position: absolute;
    top: 4px;
    right: 4px;
    left: 4px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
    pointer-events: none;
`;
